import React, { createContext, useState } from "react"

type InterfaceContextType = {
  cookieBannerVisible: boolean
  cookieModalVisible: boolean
  collectionMethodChanged: boolean
  setCookieBannerVisible: (isVisible: boolean) => void
  setCookieModalVisible: (isVisible: boolean) => void
  setCollectionMethodChanged: (hasChanged: boolean) => void
}

export const defaultContext: InterfaceContextType = {
  cookieBannerVisible: false,
  cookieModalVisible: false,
  collectionMethodChanged: false,
  setCookieBannerVisible: () => {},
  setCookieModalVisible: () => {},
  setCollectionMethodChanged: () => {},
}

export const InterfaceContext = createContext(defaultContext)

type Props = {
  children: React.ReactNode
}

export const InterfaceProvider = ({ children }: Props) => {
  const [cookieBannerVisible, setCookieBannerVisible] = useState(false)
  const [cookieModalVisible, setCookieModalVisible] = useState(false)
  const [collectionMethodChanged, setCollectionMethodChanged] = useState(false)

  return (
    <InterfaceContext.Provider
      value={{
        cookieBannerVisible,
        cookieModalVisible,
        collectionMethodChanged,
        setCookieBannerVisible,
        setCookieModalVisible,
        setCollectionMethodChanged,
      }}
    >
      {children}
    </InterfaceContext.Provider>
  )
}
